import {
  useMutation,
  UseMutationOptions,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import {
  GETProviderCategories,
  POSTProviderCategory,
  PUTProviderCategory,
} from '@/queries/providers/categories/requests'
import {
  ProviderCategory,
  CreateProviderCategory,
  UpdateProviderCategory,
} from '@/queries/providers/categories/schema'

const queryKey = ['admin_provider_categories']

export function useProviderCategories() {
  const queryClient = useQueryClient()

  const query = useQuery<ProviderCategory[]>({
    queryKey,
    queryFn: GETProviderCategories,
    refetchOnMount: 'always',
  })

  const invalidateQuery = () => {
    return queryClient.invalidateQueries({ queryKey })
  }

  return {
    query,
    invalidateQuery,
  }
}

export function usePostProviderCategory(
  options?: UseMutationOptions<unknown, unknown, CreateProviderCategory>
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateProviderCategory) => POSTProviderCategory(data),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey })
      options?.onSuccess?.(...args)
    },
    onError: options?.onError,
    onSettled: options?.onSettled,
  })
}

export function usePutProviderCategory(
  options?: UseMutationOptions<
    unknown,
    unknown,
    { id: number; data: UpdateProviderCategory }
  >
) {
  const queryClient = useQueryClient()
  const queryKey = ['admin_provider_categories']

  return useMutation({
    mutationFn: ({ id, data }) => PUTProviderCategory(id, data),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey })
      options?.onSuccess?.(...args)
    },
    onError: options?.onError,
    onSettled: options?.onSettled,
  })
}
